require('./angulartics');
module.exports = 'angulartics';



/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/~/angulartics/src/index.js
 ** module id = 213
 ** module chunks = 0
 **/